import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useErrorContext } from './../../components/messages/ErrorBox';
import { usePageLoadingContext } from './../../components/messages/PageLoading';
import { useLocale } from './../../components/special/LanguageProvider';
import { apiGetCall, apiPostCall, isResultOk } from './../../components/special/apiCall';
import EditForm from 'components/form/EditForm';
import EditFormFieldTable from 'components/form/EditFormFieldTable';
import InputDate from './../../components/input/InputDate';
import InputDropDownList from './../../components/input/InputDropDownList';
import ListTable from './../../components/form/ListTable';
import TextDate from './../../components/text/TextDate';
import TextAmount from 'components/text/TextAmount';
import InputNumber from './../../components/input/InputNumber';
import InputCheckBox from 'components/input/InputCheckBox';


const BASE_URL = process.env.REACT_APP_ILWEB_API_URL;

export const ActionCostEdit = ({ history }) => {

  const params = new URLSearchParams(useLocation().search);
  const setCheckErrorItems = useErrorContext();
  const setIsPageLoading = usePageLoadingContext();
  const { t } = useLocale();

  //Init blank formdata record.
  const [formData, setFormData] = useState({
    isNew: true
  });

  const [indexData, setIndexData] = useState({
    deferItemSel: 1,
    active: false
  });

  //Init blank working data record
  const [workingData, setWorkingData] = useState({
    actionCostID: null,
    actionID: null,
    transactionKeyID: null,
    costDate: new Date(),
    costDates: [],
    amount: 0,
    deferredConfig: {
      deferType: "Days",
      deferValue: 0
    }
  });

  const [lookupData, setLookupData] = useState({
    transactionKeyList: [],
    actionList: [],
    deferTypeList: [{
      itemID: 1,
      name: "Frestur í dögum",
      key: "Days"
    },
    {
      itemID: 2,
      name: "Frestur í mánuðum",
      key: "Months"
    },
    {
      itemID: 3,
      name: "Frestur í mánuðum - 1.mánaðar",
      key: "FirstOfMonth"
    }],
  });


  const goBack = () => {
    history.push("/admin/actioncosts");
  }


  const loadLookupData = async () => {
    //Load all the data at the same time.     
    let [transactionKeyList, actionList] = await Promise.all([
      apiGetCall(BASE_URL + '/admin/list/transactionkey/cost'),
      apiGetCall(BASE_URL + '/admin/list/action/fixedcostallowed'),

    ]);
    //Check we need to display any critical errors.
    setCheckErrorItems([transactionKeyList, actionList]);

    //Translate the data into what we want to use.
    setLookupData({
      transactionKeyList: transactionKeyList,
      actionList: actionList,
      deferTypeList: [{
        itemID: 1,
        name: "Frestur í dögum",
        key: "Days"
      },
      {
        itemID: 2,
        name: "Frestur í mánuðum",
        key: "Months"
      },
      {
        itemID: 3,
        name: "Frestur í mánuðum - 1.mánaðar",
        key: "FirstOfMonth"
      }]
    });
  }


  const loadFormData = async () => {
    setIsPageLoading(true);
    let newFormData = { ...formData };
    //Read the query parameters, if we don´t have any then go back to transaction keys.
    let isNew = params.get("new");
    if (!isNew) {
      let editID = params.get("actioncostid");
      if (editID == null || editID <= 0) {
        goBack();
      }
      else {
        newFormData.isNew = false;
        //setFormData({...formData, isNew : false});
        let requestResult = await apiGetCall(BASE_URL + '/admin/actioncost/' + editID);
        //console.log("reqRes", requestResult);
        if (isResultOk(requestResult, setCheckErrorItems)) {
          let newWorkData = { ...workingData };
          newWorkData.actionCostID = requestResult.actionCostID;
          newWorkData.actionID = requestResult.actionID;
          newWorkData.transactionKeyID = requestResult.transactionKeyID;
          newWorkData.costDate = requestResult.costDate;
          newWorkData.costDates = requestResult.costDates;
          newWorkData.amount = requestResult.amount;
          if (requestResult.deferredConfig != null) {
            newWorkData.deferredConfig.deferType = requestResult.deferredConfig.deferType;
            newWorkData.deferredConfig.deferValue = requestResult.deferredConfig.deferValue;
          }
          setWorkingData(newWorkData);

        }
      }
    }


    //Lookup data.
    await loadLookupData();

    setFormData(newFormData);

    setIsPageLoading(false);
    curDTSelection();
  }


  useEffect(() => {
    loadFormData();
  }, []);

  const onDeferTypeSel = async (value) => {
    let newType = lookupData.deferTypeList.filter(dt => dt.itemID == value);
    //console.log("selected", newType);
    let tempWD = { ...workingData };
    tempWD.deferredConfig.deferType = newType[0].key;
    //console.log("temp", tempWD);
    setWorkingData(tempWD);
    //setWorkingData({...workingData, deferType : newType[0].key});
    setIndexData({ ...indexData, deferItemSel: value });
  }

  const onDeferValueChange = async (value) => {
    let tempD = { ...workingData };
    tempD.deferredConfig.deferValue = value;
    setWorkingData(tempD);
  }

  const curDTSelection = async () => {
    setIsPageLoading(true);
    let w1 = { ...workingData };
    let curSel = lookupData.deferTypeList.filter(dt => dt.key == workingData.deferredConfig.deferType);
    let tempD = { ...indexData };
    tempD.deferItemSel = curSel[0].itemID;
    tempD.active = workingData.deferredConfig.deferValue > 0;
    setIndexData(tempD);
    setIsPageLoading(false);

  }

  const onCbChanged = async (value) => {
    let temp = { ...indexData };
    temp.active = value;
    setIndexData(temp);
    if (!value){
      let tempW = {...workingData};
      tempW.deferredConfig.deferValue = 0;
      setWorkingData(tempW);
    }
  }

  const onSaveClick = async () => {

    setIsPageLoading(true);
    let requestResult = null;
    //console.log("save", workingData, formData);
    if (formData.isNew) {
      //console.log("Test", workingData);
      requestResult = await apiPostCall(BASE_URL + '/admin/actioncost/create', workingData);
      //console.log("res", requestResult);
    }
    else {
      requestResult = await apiPostCall(BASE_URL + '/admin/actioncost/change', workingData);
    }
    if (isResultOk(requestResult, setCheckErrorItems)) {
      goBack();
    }
    setIsPageLoading(false);
  }

  const onBackClick = () => {
    goBack();
  }

  const validateInput = async () => {
    let messages = [];

    if (workingData.actionID == null || workingData.actionID === 0) {
      messages.push("Vantar að velja aðgerð");
    }

    if (workingData.transactionKeyID == null || workingData.transactionKeyID === 0) {
      messages.push("Vantar að velja færslulykil");
    }

    if (workingData.amount <= 0) {
      messages.push("Upphæð þarf að vera hærri en 0");
    }

    return messages;
  }


  return (
    <EditForm title={formData.isNew ? "Nýr fastur kostnaður" : "Uppfæra fastan kostnað"} onSubmitClick={onSaveClick} onBackClick={onBackClick} onValidate={validateInput}>
      <EditFormFieldTable fields={[
        {
          title: "Kostnaður á aðgerð",
          edit: () => <InputDropDownList
            name="ActionID"
            disabled={!formData.isNew}
            list={lookupData.actionList}
            keyField="itemID"
            displayField={(item) => { return item.name + " " + (item.itemID ? "(" + item.itemID + ")" : ""); }}
            defaultValue={workingData.actionID}
            onChange={(value) => setWorkingData({ ...workingData, actionID: value })}
            nullable={true}
            nullableItem={{ itemID: null, name: "" }}
          />
        },
        {
          title: formData.isNew ? "Tengja við færslulykill" : 'Tengdur færslulykill',
          edit: () => <InputDropDownList
            name="TransactionKeyID"
            disabled={!formData.isNew}
            list={lookupData.transactionKeyList}
            keyField="itemID"
            displayField={(item) => { return item.name + " " + (item.data ? "(" + item.data.key + ")" : ""); }}
            defaultValue={workingData.transactionKeyID}
            onChange={(value) => setWorkingData({ ...workingData, transactionKeyID: value })}
            nullable={true}
            nullableItem={{ itemID: null, name: "" }}
          />
        },
        {
          title: "Gildir frá",
          edit: () => (<InputDate name="CostDate" value={workingData.costDate} onChange={(value) => setWorkingData({ ...workingData, costDate: value })} />)
        },
        {
          title: "Upphæð",
          edit: () => (<InputNumber name="Amount" value={workingData.amount} onChange={(value) => setWorkingData({ ...workingData, amount: value })} />)
        },
      ]} />
      <div>
        <InputCheckBox name={"deferConfig"} label={"Virkja stillingar á frestun kostnað"} value={indexData.active} onChange={(value) => onCbChanged(value)} />
        <div style={{visibility: (indexData.active) ? 'visible' : 'hidden' }}>
        <EditFormFieldTable fields={[
          {
            title: "Frestun gildistöku kostnaðar",
            edit: (
              <div>
                <InputDropDownList
                  name="DeferType"
                  disabled={false}
                  list={lookupData.deferTypeList}
                  keyField="itemID"
                  displayField={(item) => { return item.name }}
                  defaultValue={indexData.deferItemSel}
                  onChange={(value) => onDeferTypeSel(value)}
                  nullable={true}
                  nullableItem={{ itemID: null, name: "" }} />
                <InputNumber name="Defer" value={workingData.deferredConfig.deferValue} onChange={(value) => onDeferValueChange(value)} />
              </div>
            )
          },
        ]} />
        </div>
      </div>

      <ListTable
        list={workingData.costDates}
        colsettings={['50%', '50%']}
        headers={[
          t("Kostnaður"),
          <div className="text-right">{t("Upphæð")}</div>,
        ]}
        columns={[
          (item) => <><TextDate value={item.costDate} />{item.isCurrent ? <span className="icon-checkmark-circle2 text-blue" data-tip="Núverandi kostnaður"></span> : null} </>,
          (item) => <div className="text-right"><TextAmount value={item.amount} /></div>,
        ]}
      />
    </EditForm>
  );
}





